var map = {
	"./ais-th/translations/index.js": 2082,
	"./demo-en/translations/index.js": 3821,
	"./mtn-ng-en/translations/index.js": 1967,
	"./mtn-wp-za-en/translations/index.js": 3100,
	"./telkom-wp-za-en/translations/index.js": 1048,
	"./wp-za-en/translations/index.js": 9079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1648;